import { Button, HStack, Text } from "@chakra-ui/react";
import React, { memo, useCallback } from "react";

import colors from "app/colors";
import { HappycoMiniLogoIcon } from "modules/icons";
import { MessageFragment, MessageThreadFragment } from "gql/graphql";
import { useAuth } from "modules/providers/auth-provider";
import { DRAWER_TYPE } from "modules/providers/overlay-provider/overlay-provider";
import useForwardMessage from "modules/hooks/use-forward-message";
import { HAPPYCO_THREAD_DRAFT_ID } from "modules/utils/Constants";

interface IProps {
  messageThread: MessageThreadFragment;
  message: MessageFragment;
}

const HappycoMessagePopoverExportToExistingWorkOrderButton: React.FC<
  IProps
> = ({ messageThread, message }) => {
  const { createLinkedThread } = useForwardMessage({
    messageThread,
    message,
    drawerType: DRAWER_TYPE.HAPPYCO_EXPORT_TO_EXISTING_WORK_ORDER,
    draftId: HAPPYCO_THREAD_DRAFT_ID,
  });
  const { organization } = useAuth();

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      createLinkedThread(e);
    },
    [createLinkedThread],
  );

  if (!organization?.happycoCustomerId) {
    return null;
  }

  return (
    <Button variant="link" onClick={onClick}>
      <HStack spacing={3}>
        <HappycoMiniLogoIcon boxSize={5} fill={colors.blue} />
        <Text fontSize={14} color={colors.blackSecondary}>
          Export to Existing Work Order
        </Text>
      </HStack>
    </Button>
  );
};

export default memo(HappycoMessagePopoverExportToExistingWorkOrderButton);
